// Frontend i18n map for the static achievements catalog.
// Backend keeps the canonical Spanish copy for backward compatibility — frontend renders by id.

export const BADGE_I18N = {
  es: {
    first_play:        { name: 'Primera Pizarra',   desc: 'Crea tu primera jugada propia.' },
    playbook_10:       { name: 'Playbook Builder',  desc: 'Crea 10 jugadas propias.' },
    playbook_50:       { name: 'Playbook Master',   desc: 'Crea 50 jugadas propias.' },
    roster_5:          { name: 'Team Builder',      desc: '5 jugadores en tu roster.' },
    roster_12:         { name: 'Full Roster',       desc: '12+ jugadores en tu roster.' },
    first_sale:        { name: 'Estreno',           desc: 'Tu primera venta en el marketplace.' },
    sales_10:          { name: 'Vendedor Activo',   desc: '10 ventas acumuladas.' },
    sales_50:          { name: 'Bestseller',        desc: '50 ventas. Eres un referente.' },
    first_purchase:    { name: 'Inversor',          desc: 'Tu primera compra en el marketplace.' },
    big_spender:       { name: 'Big Spender',       desc: '5 jugadas compradas.' },
    first_review:      { name: 'Voz Crítica',       desc: 'Deja tu primera reseña.' },
    five_star_master:  { name: '5★ Master',         desc: 'Una de tus jugadas tiene 4.5★+ con 3+ reseñas.' },
    elite_verified:    { name: 'Élite Verificado',  desc: 'Tu perfil ha sido verificado como Coach Élite.' },
    coach_of_month:    { name: 'Coach of the Month',desc: 'Fuiste Coach del Mes en el Marketplace.' },
    ai_explorer:       { name: 'AI Explorer',       desc: '10+ mensajes enviados a la IA Coach.' },
  },
  en: {
    first_play:        { name: 'First Whiteboard', desc: 'Create your first own play.' },
    playbook_10:       { name: 'Playbook Builder', desc: 'Create 10 own plays.' },
    playbook_50:       { name: 'Playbook Master',  desc: 'Create 50 own plays.' },
    roster_5:          { name: 'Team Builder',     desc: '5 players in your roster.' },
    roster_12:         { name: 'Full Roster',      desc: '12+ players in your roster.' },
    first_sale:        { name: 'Premiere',         desc: 'Your first marketplace sale.' },
    sales_10:          { name: 'Active Seller',    desc: '10 cumulative sales.' },
    sales_50:          { name: 'Bestseller',       desc: '50 sales. You are a reference.' },
    first_purchase:    { name: 'Investor',         desc: 'Your first marketplace purchase.' },
    big_spender:       { name: 'Big Spender',      desc: '5 plays purchased.' },
    first_review:      { name: 'Critical Voice',   desc: 'Leave your first review.' },
    five_star_master:  { name: '5★ Master',        desc: 'One of your plays has 4.5★+ with 3+ reviews.' },
    elite_verified:    { name: 'Elite Verified',   desc: 'Your profile is verified as Elite Coach.' },
    coach_of_month:    { name: 'Coach of the Month', desc: 'You were Coach of the Month in the Marketplace.' },
    ai_explorer:       { name: 'AI Explorer',      desc: '10+ messages sent to the AI Coach.' },
  },
  fr: {
    first_play:        { name: 'Premier Tableau',  desc: 'Créez votre premier jeu personnel.' },
    playbook_10:       { name: 'Playbook Builder', desc: 'Créez 10 jeux personnels.' },
    playbook_50:       { name: 'Playbook Master',  desc: 'Créez 50 jeux personnels.' },
    roster_5:          { name: 'Team Builder',     desc: '5 joueurs dans votre effectif.' },
    roster_12:         { name: 'Effectif Complet', desc: '12+ joueurs dans votre effectif.' },
    first_sale:        { name: 'Première',         desc: 'Votre première vente sur le marketplace.' },
    sales_10:          { name: 'Vendeur Actif',    desc: '10 ventes cumulées.' },
    sales_50:          { name: 'Bestseller',       desc: '50 ventes. Vous êtes une référence.' },
    first_purchase:    { name: 'Investisseur',     desc: 'Votre premier achat sur le marketplace.' },
    big_spender:       { name: 'Big Spender',      desc: '5 jeux achetés.' },
    first_review:      { name: 'Voix Critique',    desc: 'Laissez votre premier avis.' },
    five_star_master:  { name: '5★ Master',        desc: "L'un de vos jeux a 4,5★+ avec 3+ avis." },
    elite_verified:    { name: 'Élite Vérifié',    desc: 'Votre profil est vérifié comme Coach Élite.' },
    coach_of_month:    { name: 'Coach du Mois',    desc: 'Vous avez été Coach du Mois sur le Marketplace.' },
    ai_explorer:       { name: 'AI Explorer',      desc: '10+ messages envoyés au Coach IA.' },
  },
  pt: {
    first_play:        { name: 'Primeira Lousa',   desc: 'Crie sua primeira jogada própria.' },
    playbook_10:       { name: 'Playbook Builder', desc: 'Crie 10 jogadas próprias.' },
    playbook_50:       { name: 'Playbook Master',  desc: 'Crie 50 jogadas próprias.' },
    roster_5:          { name: 'Team Builder',     desc: '5 jogadores no seu elenco.' },
    roster_12:         { name: 'Elenco Completo',  desc: '12+ jogadores no seu elenco.' },
    first_sale:        { name: 'Estreia',          desc: 'Sua primeira venda no marketplace.' },
    sales_10:          { name: 'Vendedor Ativo',   desc: '10 vendas acumuladas.' },
    sales_50:          { name: 'Bestseller',       desc: '50 vendas. Você é referência.' },
    first_purchase:    { name: 'Investidor',       desc: 'Sua primeira compra no marketplace.' },
    big_spender:       { name: 'Big Spender',      desc: '5 jogadas compradas.' },
    first_review:      { name: 'Voz Crítica',      desc: 'Deixe sua primeira avaliação.' },
    five_star_master:  { name: '5★ Master',        desc: 'Uma de suas jogadas tem 4,5★+ com 3+ avaliações.' },
    elite_verified:    { name: 'Élite Verificado', desc: 'Seu perfil foi verificado como Coach Élite.' },
    coach_of_month:    { name: 'Coach do Mês',     desc: 'Você foi Coach do Mês no Marketplace.' },
    ai_explorer:       { name: 'AI Explorer',      desc: '10+ mensagens enviadas à IA Coach.' },
  },
  zh: {
    first_play:        { name: '首份战术板',       desc: '创建你的第一个自有战术。' },
    playbook_10:       { name: '战术库建设者',     desc: '创建 10 个自有战术。' },
    playbook_50:       { name: '战术库大师',       desc: '创建 50 个自有战术。' },
    roster_5:          { name: '球队建设者',       desc: '名单中有 5 名球员。' },
    roster_12:         { name: '完整名单',         desc: '名单中有 12+ 名球员。' },
    first_sale:        { name: '首秀',             desc: '你在市场上的首次销售。' },
    sales_10:          { name: '活跃卖家',         desc: '累计 10 次销售。' },
    sales_50:          { name: '畅销作者',         desc: '50 次销售。你是榜样。' },
    first_purchase:    { name: '投资者',           desc: '你在市场上的首次购买。' },
    big_spender:       { name: '大手笔',           desc: '已购买 5 个战术。' },
    first_review:      { name: '评论之声',         desc: '留下你的第一条评论。' },
    five_star_master:  { name: '5★ 大师',          desc: '你的一个战术拥有 4.5★+ 和 3+ 评论。' },
    elite_verified:    { name: '精英认证',         desc: '你的资料已认证为精英教练。' },
    coach_of_month:    { name: '月度教练',         desc: '你曾是市场上的月度教练。' },
    ai_explorer:       { name: 'AI 探索者',        desc: '向 AI 教练发送了 10+ 条消息。' },
  },
  ar: {
    first_play:        { name: 'أول لوحة',        desc: 'أنشئ خطتك الأولى.' },
    playbook_10:       { name: 'باني الكتاب',      desc: 'أنشئ 10 خطط ذاتية.' },
    playbook_50:       { name: 'سيد الكتاب',       desc: 'أنشئ 50 خطة ذاتية.' },
    roster_5:          { name: 'باني الفريق',      desc: '5 لاعبين في قائمتك.' },
    roster_12:         { name: 'قائمة كاملة',      desc: '12+ لاعبًا في قائمتك.' },
    first_sale:        { name: 'العرض الأول',      desc: 'أول عملية بيع لك في المتجر.' },
    sales_10:          { name: 'بائع نشط',         desc: '10 مبيعات تراكمية.' },
    sales_50:          { name: 'الأكثر مبيعًا',    desc: '50 عملية بيع. أنت مرجع.' },
    first_purchase:    { name: 'مستثمر',           desc: 'أول عملية شراء لك في المتجر.' },
    big_spender:       { name: 'منفق كبير',        desc: 'تم شراء 5 خطط.' },
    first_review:      { name: 'صوت نقدي',         desc: 'اترك أول مراجعة لك.' },
    five_star_master:  { name: 'سيد 5★',          desc: 'إحدى خططك حصلت على 4.5★+ و 3+ مراجعات.' },
    elite_verified:    { name: 'نخبة موثّق',       desc: 'تم التحقق من ملفك كمدرب نخبة.' },
    coach_of_month:    { name: 'مدرب الشهر',       desc: 'كنت مدرب الشهر في المتجر.' },
    ai_explorer:       { name: 'مستكشف الذكاء',    desc: '10+ رسائل أرسلت لمدرب الذكاء.' },
  },
};

export function localizeBadge(badge, lang) {
  if (!badge) return badge;
  const tr = BADGE_I18N[lang]?.[badge.id];
  if (!tr) return badge;
  return { ...badge, name: tr.name, desc: tr.desc };
}
